import axios from "../helper/axios";

export function CanSignIn(data, callback) {
  return async (dispatch) => {
    try {
      //console.log("qcecLogin req", data);
      const response = await axios.post("qsetLogin", data);
      //console.log("qcecLogin", response.data);
      //console.log("qcecLogin Seesion", response.data.session);
      callback(null, "success",response.data.session); // Pass null or undefined in the success case
    } catch (error) {
      console.error(error);
      console.error(error.response.data.error);
      localStorage.setItem("errormessage", error.response.data.error);
      callback(error.response.data.error, "error");
    }
  };
}

export function CanResendOTP(data, callback) {
  return async (Dispatch) => {
    try {
      //console.log("ResendOTP Data", data);
      const response = await axios.post("/qsetResendOtp", data);
      //console.log("/users/resendotp", response.data);
      callback(null, "success");
    } catch (e) {
      console.log(e);
      callback(e.message, "Resend OTP Failed");
    }
  };
}

export function CanVerifySigninOtp(data, callback) {
  //console.log("/qcecVerifyOtp", data);
  return async (Dispatch) => {
    axios
      .post("/qsetVerifyOtp", data)
      .then((res) => {
        console.log(res);
        localStorage.setItem("qsetUserDetails",JSON.stringify(res.data.qsetUserData))
        //Dispatch({ type: "SIGNIN", payload: res.data.user });
        console.log("localstorage",localStorage)
        callback(null, "success");
      })
      .catch((e) => {
        console.log(e)
        console.log("This is the error that im looking at");
        callback(e.response.data.error, "Still Dont know the error");
      });
  };
}

export function CanLogout(data,callback) {
  console.log("log out called",data)
  return async (Dispatch) => {
    axios
      .post("/qsetLogout")  
      .then((res) => {
        console.log(res)
        localStorage.removeItem("token")
        Dispatch({ type: "LOGOUT", payload: res.data });
        callback()
      })
      .catch((e) => console.log(e));
  };
}
